import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioOportunidadeUpdatePerdido } from '../perdido';
import { NegocioOportunidadeSearch } from '../negocio-oportunidade-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadePerdidoHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Atualiza os dados da perda de um negócio */
    update(update: NegocioOportunidadeUpdatePerdido): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.put<NegocioOportunidadeSearch>(`${this.pathApi}/${update.idNegocio}/perdido`, update);
    }
}
